<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M.062.063h20.125v20.124H.062V.063z" />
    <path
      d="M19.858 17.103v2.755H.062v-2.755h19.796zM11.335.063v9.356l3.567-3.553 1.941 1.943-6.884 6.885L3.07 7.809l1.943-1.943L8.58 9.42V.063h2.754z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
